import styled from "styled-components";

export const FlexRowResponsive = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: ${({theme}) => theme.breakpoints.xxl}) {
    flex-direction: column;
  }
`;
